// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2grVA","errorLogs":"EditorFooter_errorLogs__3R5sO"};